/* Contentsquare (CSQ / Hotjar) analytics tag — loads site-wide, first so it captures from page start */
(function(){
  if(window.__siora_csq)return;window.__siora_csq=1;
  var s=document.createElement('script');
  s.src='https://t.contentsquare.net/uxa/311ff251317b2.js';
  s.defer=true;
  (document.head||document.documentElement).appendChild(s);
})();

(function(){
  var KEY='siora_wishlist_v1';
  function load(){try{return JSON.parse(localStorage.getItem(KEY))||[];}catch(e){return [];}}
  function save(a){try{localStorage.setItem(KEY,JSON.stringify(a));}catch(e){}}
  function has(items,k){return items.some(function(i){return i.k===k;});}
  var HEART_SEL='.pc__w,.pcard__wish,.sscard__wish,.spot-card__wish,.spd__acts .wish';
  function keyFor(btn){
    if(btn.closest('.spd')){return location.pathname.split('?')[0];}
    var card=btn.closest('.pc,.pcard,.sscard,.spot-card');
    var a=card&&card.querySelector('a[href*="/products/"]');
    if(!a){a=btn.closest('a[href*="/products/"]');}
    if(a){try{return new URL(a.getAttribute('href'),location.origin).pathname;}catch(e){return a.getAttribute('href');}}
    return null;
  }
  function meta(btn,k){
    var title='',img='';
    if(btn.closest('.spd')){var nm=document.querySelector('.spd__name');title=nm?nm.textContent.trim():document.title;var si=document.querySelector('.spd__slide img');img=si?si.src:'';}
    else{var card=btn.closest('.pc,.pcard,.sscard,.spot-card');if(card){var t=card.querySelector('.pc__n,.pcard__name,.sscard__name,.spot-card__name');title=t?t.textContent.trim():'';var im=card.querySelector('img');img=im?im.src:'';}}
    return {k:k,t:title,img:img,u:k};
  }
  function paint(btn,on){
    btn.classList.toggle('is-wished',on);
    var svg=btn.querySelector('svg');
    if(svg){svg.style.fill=on?'currentColor':'none';}
    else{var t=(btn.textContent||'').trim();if(t==='♡'||t==='♥'||t===''){btn.textContent=on?'♥':'♡';}}
  }
  function reflect(){
    var items=load();
    document.querySelectorAll(HEART_SEL).forEach(function(btn){var k=keyFor(btn);paint(btn,!!(k&&has(items,k)));});
    var n=items.length;
    document.querySelectorAll('[data-wishcount]').forEach(function(el){el.textContent=n;el.style.display=n>0?'':'none';});
  }
  function toggle(btn){
    var k=keyFor(btn);if(!k)return;var items=load();
    if(has(items,k)){items=items.filter(function(i){return i.k!==k;});}
    else{items.push(meta(btn,k));}
    save(items);reflect();
  }
  function ensurePanel(){
    if(document.getElementById('siora-wl'))return;
    var d=document.createElement('div');d.id='siora-wl';
    d.innerHTML='<div class="swl-ov" data-wishclose></div><aside class="swl-panel" aria-label="Wishlist"><div class="swl-top"><span>My Wishlist</span><button type="button" data-wishclose aria-label="Close">&times;</button></div><div class="swl-body"></div></aside>';
    document.body.appendChild(d);
  }
  function renderPanel(){ensurePanel();var b=document.querySelector('#siora-wl .swl-body');var items=load();
    if(!items.length){b.innerHTML='<div class="swl-empty">Your wishlist is empty.<br>Tap the &#9825; on any product to save it here.</div>';return;}
    b.innerHTML=items.map(function(i){return '<div class="swl-item"><a href="'+i.u+'" class="swl-thumb">'+(i.img?'<img src="'+i.img+'" alt="">':'')+'</a><a href="'+i.u+'" class="swl-name">'+(i.t||'View product')+'</a><button type="button" class="swl-x" data-wishremove="'+i.k+'" aria-label="Remove">&times;</button></div>';}).join('');
  }
  function openPanel(){ensurePanel();renderPanel();document.body.classList.add('swl-open');}
  function closePanel(){document.body.classList.remove('swl-open');}
  document.addEventListener('click',function(e){
    var h=e.target.closest(HEART_SEL);
    if(h){e.preventDefault();e.stopPropagation();toggle(h);return;}
    if(e.target.closest('[data-wishopen]')){e.preventDefault();openPanel();return;}
    if(e.target.closest('[data-wishclose]')){e.preventDefault();closePanel();return;}
    var rm=e.target.closest('[data-wishremove]');
    if(rm){e.preventDefault();var k=rm.getAttribute('data-wishremove');save(load().filter(function(i){return i.k!==k;}));reflect();renderPanel();return;}
  },true);
  if(document.readyState!=='loading'){reflect();}else{document.addEventListener('DOMContentLoaded',reflect);}
  window.addEventListener('pageshow',reflect);
  window.SioraWishlist={reflect:reflect,open:openPanel};
})();

/* Siora pincode serviceability — pan-India (all valid 6-digit Indian PINs serviceable) */
(function(){
  var st=document.createElement('style');
  st.textContent='.spd__pinmsg{margin-top:8px;font-size:13px;line-height:1.45;}.spd__pinmsg.is-ok{color:#1a7f37;}.spd__pinmsg.is-ok strong{color:#1a7f37;font-weight:600;}.spd__pinmsg.is-err{color:#c0392b;}';
  if(document.head){document.head.appendChild(st);}
  function msgEl(pin){var m=pin.parentNode.querySelector('.spd__pinmsg');if(!m){m=document.createElement('div');m.className='spd__pinmsg';pin.insertAdjacentElement('afterend',m);}return m;}
  function check(pin){var inp=pin.querySelector('input');if(!inp){return;}var v=(inp.value||'').replace(/\D/g,'');var m=msgEl(pin);if(/^[1-9][0-9]{5}$/.test(v)){m.className='spd__pinmsg is-ok';m.innerHTML='✓ <strong>Delivery available</strong> at '+v+' — we ship pan-India. Estimated 4–7 business days.';}else{m.className='spd__pinmsg is-err';m.textContent='Please enter a valid 6-digit pincode.';}}
  document.addEventListener('click',function(e){var btn=e.target.closest('.spd__pin button');if(btn){e.preventDefault();var pin=btn.closest('.spd__pin');if(pin){check(pin);}}},true);
  document.addEventListener('keydown',function(e){if(e.key==='Enter'){var inp=e.target.closest('.spd__pin input');if(inp){e.preventDefault();var pin=inp.closest('.spd__pin');if(pin){check(pin);}}}},true);
  document.addEventListener('input',function(e){var inp=e.target.closest('.spd__pin input');if(inp){var c=inp.value.replace(/\D/g,'').slice(0,6);if(c!==inp.value){inp.value=c;}var pin=inp.closest('.spd__pin');var m=pin&&pin.parentNode.querySelector('.spd__pinmsg');if(m){m.remove();}}},true);
})();

/* Hide leftover Dawn search box (/search) + slim GIVA-style Buy/Add buttons */
(function(){
  function fix(){
    var s=document.querySelectorAll('.template-search__search');for(var i=0;i<s.length;i++){s[i].style.setProperty('display','none','important');}
    var b=document.querySelectorAll('.spd__bar .buy, .spd__bar .cart');
    for(var j=0;j<b.length;j++){var el=b[j];
      el.style.setProperty('height','auto','important');
      el.style.setProperty('min-height','38px','important');
      el.style.setProperty('padding','9px 12px','important');
      el.style.setProperty('font-size','12.5px','important');
      el.style.setProperty('font-weight','600','important');
      el.style.setProperty('letter-spacing','.5px','important');
      el.style.setProperty('text-transform','uppercase','important');
      el.style.setProperty('border-radius','4px','important');
      el.style.setProperty('line-height','1.1','important');
    }
  }
  if(document.readyState!=='loading'){fix();}else{document.addEventListener('DOMContentLoaded',fix);}
  window.addEventListener('pageshow',fix);
  document.addEventListener('shopify:section:load',fix);
  setTimeout(fix,800);
})();

/* Believable ratings: vary card + PDP rating 4.5-4.9 & PDP review count <70, seeded by product name (stable, consistent card<>PDP) */
(function(){
  function h(s){var a=2166136261;for(var i=0;i<s.length;i++){a^=s.charCodeAt(i);a=Math.imul(a,16777619);}return a>>>0;}
  function seedOf(t){return (t||'').toLowerCase().replace(/[^a-z0-9]/g,'').slice(0,40);}
  function ratingFor(t){var s=h(seedOf(t));return ((45+(s%5))/10).toFixed(1);}
  function countFor(t){var s=h(seedOf(t));return 18+((s>>4)%51);}
  function setRatingLeaf(el,r){var done=false;el.querySelectorAll('*').forEach(function(x){if(!done&&x.children.length===0&&/^\s*\d\.\d\s*$/.test(x.textContent)){x.textContent=r;done=true;}});if(!done){el.childNodes.forEach(function(n){if(n.nodeType===3&&/\d\.\d/.test(n.nodeValue)){n.nodeValue=n.nodeValue.replace(/\d\.\d/,r);done=true;}});}return done;}
  function cards(){
    document.querySelectorAll('.sscard__rate,.spot-card__rate,.pcard__rate,.pc__rate').forEach(function(el){
      var card=el.closest('.sscard,.spot-card,.pcard,.pc');if(!card)return;
      var nm=card.querySelector('[class*="name" i],[class*="title" i]');
      var t=nm?nm.textContent:'';if(!seedOf(t))return;
      setRatingLeaf(el,ratingFor(t));
    });
  }
  function pdp(){
    var nmEl=document.querySelector('.spd__name');if(!nmEl)return;
    var t=nmEl.textContent;if(!seedOf(t))return;
    var r=ratingFor(t), c=countFor(t);
    document.querySelectorAll('.spd__rate .c').forEach(function(el){el.textContent=el.textContent.replace(/\d{1,3}/,c);});
    document.querySelectorAll('.spd__rate').forEach(function(el){setRatingLeaf(el,r);});
    document.querySelectorAll('.rc').forEach(function(el){el.textContent=el.textContent.replace(/\d{1,3}/,c);});
    var big=document.querySelector('.rv-big');if(big&&/^\s*\d\.\d\s*$/.test(big.textContent)){big.textContent=r;}
    var bars=[].slice.call(document.querySelectorAll('.rv-bars .rv-bar'));
    if(bars.length){
      var oc=bars.map(function(b){var lf=[].slice.call(b.querySelectorAll('*')).filter(function(x){return x.children.length===0&&/^\d{1,3}$/.test(x.textContent.trim());});return lf.length?parseInt(lf[lf.length-1].textContent,10):0;});
      var ot=oc.reduce(function(a,b){return a+b;},0)||1;
      var sc=oc.map(function(x){return Math.round(x*c/ot);});
      var sm=sc.reduce(function(a,b){return a+b;},0);var df=c-sm;
      if(df!==0){var mi=sc.indexOf(Math.max.apply(null,sc));sc[mi]=Math.max(0,sc[mi]+df);}
      bars.forEach(function(b,i){var lf=[].slice.call(b.querySelectorAll('*')).filter(function(x){return x.children.length===0&&/^\d{1,3}$/.test(x.textContent.trim());});if(lf.length){lf[lf.length-1].textContent=sc[i];}});
    }
  }
  function run(){try{cards();}catch(e){} try{pdp();}catch(e){}}
  if(document.readyState!=='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  window.addEventListener('pageshow',run);
  document.addEventListener('shopify:section:load',run);
  setTimeout(run,700);
})();

/* Update PDP "Offers For You" box to the current tiered ladder */
(function(){
  var OFFERS=[['₹200','₹1,499+'],['₹500','₹3,999+'],['10%','₹5,999+']];
  function offers(){
    var card=document.querySelector('.spd__offers .card');
    if(!card)return;
    var first=card.querySelector('.spd__offer .ot');
    if(first && first.textContent.indexOf('1,499+')>-1)return;
    var anchor=card.querySelector('h3')||card.firstElementChild;
    if(!anchor)return;
    var rows=card.querySelectorAll('.spd__offer');
    for(var i=0;i<rows.length;i++){rows[i].remove();}
    for(var j=OFFERS.length-1;j>=0;j--){
      var d=document.createElement('div');d.className='spd__offer';
      d.innerHTML='<span class="tg"><svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg></span><span class="ot">FLAT '+OFFERS[j][0]+' OFF on orders '+OFFERS[j][1]+'</span>';
      anchor.insertAdjacentElement('afterend', d);
    }
  }
  if(document.readyState!=='loading'){offers();}else{document.addEventListener('DOMContentLoaded',offers);}
  window.addEventListener('pageshow',offers);
  document.addEventListener('shopify:section:load',offers);
  setTimeout(offers,600);
})();

/* GIVA/Palmonas price style: hide "% off" + show selling price first (site-wide) */
(function(){
  var st=document.createElement('style');
  st.textContent='.spd__pl .off{display:none!important;}.spd__pl .cur{order:1;}.spd__pl .cmp{order:2;}.price--on-sale .price__sale{display:flex;align-items:baseline;flex-wrap:wrap;}.price--on-sale .price__sale .price-item--sale{order:-1;margin-right:8px;}';
  (document.head||document.documentElement).appendChild(st);
  function strip(){var b=document.querySelectorAll('.card__badge .badge');for(var i=0;i<b.length;i++){if((b[i].textContent||'').indexOf('%')>-1){b[i].remove();}}}
  if(document.readyState!=='loading'){strip();}else{document.addEventListener('DOMContentLoaded',strip);}
  window.addEventListener('pageshow',strip);
  document.addEventListener('shopify:section:load',strip);
  setTimeout(strip,700);
})();
